import constants from '@/app-configs/constants'

export default [
  {
    path: '/usersettings',
    name: 'usersettings',
    component: () => import('@/views/usersettings/UserSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_USER_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_USER_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
